import * as Yup from 'yup'

export const OfferCandidatesSchema = Yup.object().shape({
  collectDataTemplateId: Yup.string().required(
    'Choose the onboarding template these candidates should go through',
  ),
})
